import moneyFormatter from "./moneyFormatter";

const formatPrice = (price) => {
    if (!price) {
        price = 0;
    } else if (price >= 1000000) {
        return moneyFormatter(1).format(price / 1000000) + "M";
    } else if (price >= 1000) {
        return moneyFormatter(0).format(price / 1000) + "K";
    }

    return moneyFormatter(0).format(price);
};

export default formatPrice;
